"use strict";

var _defineProperty = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var address_1 = require("../address");

var constants_1 = require("../constants");

var hex_1 = require("../hex");

var sharedHelpers_1 = require("./sharedHelpers");

function decodeNonArrayData(mainType, data) {
  var result = null;

  if (mainType === 'uint') {
    mainType = 'uint256';
  }

  if (mainType === 'bytes' || mainType === 'string') {
    var size = parseInt(data.slice(0, 64), 16) * 2;
    result = data.slice(64, 64 + size);
    result = mainType === 'bytes' ? "0x".concat(result) : Buffer.from(result, 'hex').toString(constants_1.BUFFER_TEXT_ENCODING);
  } else {
    switch (mainType) {
      case 'address':
        result = address_1.toChecksumAddress("".concat(constants_1.HEX_PREFIX).concat(data.slice(24)));
        break;

      case 'bool':
        result = !!parseInt(data, 16);
        break;

      default:
        var _sharedHelpers_1$pars = sharedHelpers_1.parseType(mainType),
            type = _sharedHelpers_1$pars.type,
            bytes = _sharedHelpers_1$pars.bytes;

        switch (type) {
          case 'uint':
            result = new bn_js_1.default(data, 16);
            break;

          case 'bytes':
            result = "".concat(constants_1.HEX_PREFIX).concat(data.slice(0, bytes * 2));
            break;
        }

    }
  }

  return result;
}

function decode(params, data) {
  var indexed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var result = null;

  if (hex_1.isHex(data, 'data')) {
    result = indexed ? {
      length: params.length
    } : {};
    data = data.slice(2);

    for (var i = 0; i < params.length; i += 1) {
      var type = params[i].type;
      var name = params[i].name;

      if (!name) {
        name = 'result';
      } else if (name.startsWith('_')) {
        name = name.slice(1);
      }

      var paramData = data.slice(i * 64, (i + 1) * 64);

      if (type === 'string' || type === 'bytes' || type.endsWith('[]')) {
        paramData = data.slice(parseInt(paramData, 16) * 2);
      }

      var value = null;

      if (type.endsWith('[]')) {
        var size = parseInt(paramData.slice(0, 64), 16);
        value = [];
        value = value;
        var innerType = type.slice(0, -2);

        if (innerType === 'string' || innerType === 'bytes') {
          throw new Error("".concat(type, " not supported"));
        }

        for (var j = 0; j < size; j += 1) {
          var innerData = paramData.slice((j + 1) * 64, (j + 2) * 64);
          value.push(decodeNonArrayData(innerType, innerData));
        }
      } else {
        value = decodeNonArrayData(type, paramData);
      }

      result = Object.assign(Object.assign({}, result), _defineProperty({}, name, value));

      if (indexed) {
        result = Object.assign(Object.assign({}, result), _defineProperty({}, i, value));
      }
    }
  }

  return result;
}

exports.decode = decode;